import { createFileRoute } from "@tanstack/react-router";
import { Bell, Palette } from "lucide-react";

import { AppearanceSection } from "@/components/configuracoes/AppearanceSection";
import { SettingsCard } from "@/components/configuracoes/SettingsCard";
import { PushNotifications } from "@/components/push-notifications";

export const Route = createFileRoute("/_authed/configuracoes/painel")({
  staticData: {
    title: "Painel",
    subtitle: "Aparência e notificações do navegador.",
  },
  component: PainelPage,
});

/** Os dois ajustes que valem pra ESTE navegador, não pro salão. */
function PainelPage() {
  return (
    <div className="space-y-6">
      <SettingsCard
        icon={Bell}
        title="Notificações"
        description="O aviso que chega com o painel fechado — agendamento do bot e cancelamento do cliente."
      >
        <PushNotifications />
      </SettingsCard>

      <SettingsCard icon={Palette} title="Aparência">
        <AppearanceSection />
      </SettingsCard>
    </div>
  );
}
